module.exports = __webpack_public_path__ + "static/media/Userpic2.afe64be5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Userpic2.jpg
// module id = 226
// module chunks = 0